import { z } from 'zod';
import { UuidString } from '../../primitives.js';

/**
 * Task-module SSE events (BE-S12.3-3/4 ↔ FE-S12.1-13).
 *
 * Structural-only (i18n invariant — никакого freeform message):
 * FE локализует по `kind` + UUID-refs. `event_id` — для дедупликации
 * на reconnect (replay list).
 */

export const TaskModuleEventKind = z.enum([
  'task.created',
  'task.updated',
  'task.deleted',
  'comment.added',
  'assignee.changed',
  'dependency.added',
  'dependency.removed',
  'state.changed',
  // BB8 — M2M membership: add/remove проекта. `task.project_removed` несёт
  // project_id СНЯТОГО проекта (публикуется в его канал → FE инвалидирует именно тот).
  'task.project_added',
  'task.project_removed',
]);
export type TaskModuleEventKind = z.infer<typeof TaskModuleEventKind>;

export const TaskModuleEvent = z.object({
  event_id: UuidString.optional(),
  kind: TaskModuleEventKind,
  entity_id: UuidString,
  project_id: UuidString,
  task_id: UuidString,
  /** Кто сделал мутацию (для self-event подавления на FE). */
  actor_user_id: UuidString.nullable(),
  /** Целевые юзеры (assignee.changed / mention) — для user-channel routing. */
  target_user_ids: z.array(UuidString).default([]),
  /**
   * work-tasks-performance B13 — идентификатор ВКЛАДКИ, породившей мутацию.
   *
   * `actor_user_id` для этого не годится: у одного человека вкладок может быть
   * несколько, и вторая обязана обновиться от действия первой. Отличать надо не
   * человека, а источник события — иначе собственная мутация возвращается эхом и
   * вызывает второй полный рефетч списка (нарушение инварианта I3).
   *
   * Приходит из опционального заголовка `X-Client-Id`. Поля нет — событие
   * обрабатывается как чужое (старая вкладка и старый клиент не ломаются).
   */
  origin_client_id: UuidString.optional(),
  at: z.string().datetime({ offset: true }),
});
export type TaskModuleEvent = z.infer<typeof TaskModuleEvent>;
